import React, {useState} from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = (props) => {
    // const [value, setValue] = useState(props?.textdata);
    const modules = {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image', 'video'],
          ['clean']
        ],
    };
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
    ];
    // props.returndata(value)
    return (
        <>
            <ReactQuill 
                theme="snow" 
                value={props?.textdata} 
                modules={modules}
                formats={formats}
                // onChange={setValue}
                onChange={props?.returndata}
                returndata
            />
            {/* {JSON.stringify(props.textdata)} */}
        </>
    )
};
export default RichTextEditor;